var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRazorpayTrusted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H8C3.58172 0 0 3.58172 0 8V68C0 72.4183 3.58172 76 8 76H68C72.4183 76 76 72.4183 76 68V8C76 3.58172 72.4183 0 68 0Z",
    fill: "#FCEBE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9892 16L30.292 30.5744L28.2518 38.5919L39.7648 30.535L32.2453 61H39.876L50.9892 16ZM36.7809 34.9338L17.8893 48.1862L14.7178 61H30.3719L36.7809 34.9338Z",
    fill: "#02475E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5698 32.08H53.5048L50.9998 29.5H47.2948L46.4998 28.75V25.12L43.9648 22.54V21.475L46.4998 18.895V15.25L47.2948 14.5H50.9998L53.5048 11.935H54.5698L57.1498 14.5H60.7948L61.5448 15.235V18.895L64.1098 21.475V22.54L61.4998 25.12V28.75L60.7498 29.5H57.1498L54.5698 32.08ZM52.0948 25.72H53.1598L58.8148 20.065L57.7498 19L52.6348 24.13L50.5648 22.06L49.4998 23.125L52.0948 25.72Z",
    fill: "#F78670"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.7073,
    height: 45,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRazorpayTrusted);
export default __webpack_public_path__ + "static/media/RazorpayTrusted.25260a930cfa9f5e50fc0c8835522a7a.svg";
export { ForwardRef as ReactComponent };